module.exports = __webpack_public_path__ + "static/media/logo.eee766dd.svg";